export default __webpack_public_path__ + "002ae452225953f10e405201dab6c0ed.png";